import { createContext, PropsWithChildren, useContext, useMemo } from 'react';

interface AssetContextProps {
  basePublicFilesUrl: string;
  getAssetUrl: (paths: string[]) => string;
}

const AssetContext = createContext<AssetContextProps | undefined>(undefined);

export const AssetProvider: React.FC<
  PropsWithChildren<{ basePublicFilesUrl: string }>
> = ({ children, basePublicFilesUrl }) => {
  // Memoized so getAssetUrl is referentially stable — consumers list it in
  // hook dependencies (e.g. the offline sync providers' init callbacks).
  const value = useMemo<AssetContextProps>(
    () => ({
      basePublicFilesUrl,
      getAssetUrl: (paths: string[]) =>
        [basePublicFilesUrl, ...paths].join('/'),
    }),
    [basePublicFilesUrl]
  );

  return (
    <AssetContext.Provider value={value}>{children}</AssetContext.Provider>
  );
};

export const useAssetContext = (): AssetContextProps => {
  const context = useContext(AssetContext);
  if (!context) {
    throw new Error('useAssetContext must be used within an AssetProvider');
  }
  return context;
};
